import React, { useContext } from "react";
//import { makeStyles } from "@mui/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ViewContext } from "./contexts/ViewContext";
import Header from "./Header";
import PoiSelect from "./PoiSelect";
import PoiEdit from "./PoiEdit";
import PoiThanks from "./PoiThanks";
import Home from "./Home";
import ObstacleLocation from "./ObstacleLocation";
import "mapbox-gl/dist/mapbox-gl.css";
import ObstacleReport from "./ObstacleReport";

export default function Main(props) {
    const { view } = useContext(ViewContext);

    const contents = {
        poi: [
            { hu: "", en: "", content: <Home /> },
            {
                hu: "Hely kiválasztása",
                en: "Select venue",
                content: <PoiSelect />,
            },
            { hu: "Hely értékelése", en: "Assess venue", content: <PoiEdit /> },
            { hu: "Köszönjük", en: "Thank you", content: <PoiThanks /> },
        ],
        obstacle: [
            { hu: "", en: "", content: <Home /> },
            {
                hu: "Akadály helye",
                en: "Obstacle location",
                content: <ObstacleLocation />,
            },
            {
                hu: "Akadály jelentése",
                en: "Report obstacle",
                content: <ObstacleReport />,
            },
        ],
    };

    return (
        <>
            <CssBaseline />

            {view.pageNo !== 0 && view.pageNo !== 3 && (
                <>
                    <Header
                        title={
                            contents[view.pageType][view.pageNo][view.locale]
                        }
                    />
                </>
            )}
            <div style={{ margin: 12, marginTop: 68 }}>
                {contents[view.pageType][view.pageNo].content}
            </div>
        </>
    );
}
